module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid-service-1"
  }, [_c('section', [_c('div', {
    staticClass: "ctx"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.zxzx()
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-zaixianzixun"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("在线咨询")])]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.sqmj()
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-shequminjing"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("社区民警")])]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.yqdj()
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-yangquandengji"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("养犬登记")])]), _vm._v(" "), _c('a', {
    staticClass: "item-big-text",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.wfzjlzm()
      }
    }
  }, [_c('svg', {
    staticClass: "icon",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": "#icon-wufanzuijiluzhengming"
    }
  })]), _vm._v(" "), _c('div', [_vm._v("无犯罪记录证明")])]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.openWdcs
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.wdcs
    }
  }), _vm._v(" "), _c('div', [_vm._v("我的长沙")])]), _vm._v(" "), _c('a', {
    staticClass: "item-big-text",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        _vm.hnga()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.hngaImg
    }
  }), _vm._v(" "), _c('div', [_vm._v("湖南公安服务平台")])])])]), _vm._v(" "), (_vm.isShowTraffic) ? _c('TrafficDialog', {
    attrs: {
      "show": _vm.isShowTraffic
    },
    on: {
      "close": _vm.closeTraffic
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowHousehold) ? _c('HouseholdDialog', {
    attrs: {
      "show": _vm.isShowHousehold
    },
    on: {
      "close": _vm.closeHousehold
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowResidence) ? _c('ResidenceDialog', {
    attrs: {
      "show": _vm.isShowResidence
    },
    on: {
      "close": _vm.closeResidence
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowQrcode) ? _c('QrcodeDialig', {
    attrs: {
      "show": _vm.isShowQrcode
    },
    on: {
      "close": function($event) {
        _vm.isShowQrcode = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-24a95985"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/police_service/police_service.vue
// module id = 309
// module chunks = 40